import { render, staticRenderFns } from "./Desensitize.vue?vue&type=template&id=190e3e29&scoped=true"
import script from "./Desensitize.vue?vue&type=script&lang=js"
export * from "./Desensitize.vue?vue&type=script&lang=js"
import style0 from "./Desensitize.vue?vue&type=style&index=0&id=190e3e29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190e3e29",
  null
  
)

export default component.exports